import type { DomainMapper } from '../types';

const us: DomainMapper = {
  countryCode: 'us',
  currency: 'USD',
  dataAreaId: 'us40',
  domain: 'kahrs-preview.iveo.store',
  environment: 'preview',
  flagUrl: '/flags/US.svg',
  languagePrimary: true,
  locale: 'en-us',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'product',
  sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-us.xml',
  storyblokBasePath: 'us',
  url: 'https://kahrs-preview.iveo.store/us',
  algoliaIndex: 'b2b-us-en-US-products',
  algoliaIndexAutocomplete: 'b2b-us-en-US-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1357,
  subFolder: true,
  measurement: 'imperial',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1357,
    algoliaIndex: 'b2b-us-en-US-products',
    algoliaIndexAutocomplete: 'b2b-us-en-US-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-us.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1472,
    algoliaIndex: 'b2c-us-en-US-products',
    algoliaIndexAutocomplete: 'b2c-us-en-US-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'product',
    sitemapUrl: 'https://kahrs-preview.stage3.iveo.se/storage/sitemaps/sitemap-us-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
  showNonPublicProducts: true,
} as DomainMapper;

export default us;
